module.exports = __webpack_public_path__ + "media/images/favicon/icon-9985b5bc1ff342825e6afd12a284eb99.png";